import type { Config } from "../domain/config.type.js";

export type DateOption = {
	date: Date;
	value: string;
	htmlContent: string;
};

const userRegion = document.querySelector<HTMLElement>("html")?.lang ?? undefined;

const dateFormatter = new Intl.DateTimeFormat(userRegion, {});
const dateFormatterDayOfWeek = new Intl.DateTimeFormat(userRegion, { weekday: "long", month: undefined, year: undefined, day: undefined });
const dateFormatterLong = new Intl.DateTimeFormat(userRegion, { year: undefined, month: "long", day: "numeric" });
const rtf = new Intl.RelativeTimeFormat(userRegion, { numeric: "auto" });

/**
 * todo: Move to utils
 * @param str
 */
function capitalze(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function combineYMD(year: number, month: number, day: number): `${number}-${number}-${number}` {
	// @ts-expect-error
	return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
}

export function generateDates(config: Config): DateOption[] {
	const now = new Date();
	now.setHours(0, 0, 0, 0);
	let amountOfDates = config.daysInAdvance;

	if (!config.todayOpen) {
		amountOfDates += 1;
	}

	if (!config.tomorrowOpen) {
		amountOfDates += 1;
	}

	const dates: DateOption[] = [];

	const templateEl = document.querySelector<HTMLTemplateElement>(config.labelTemplateSelector);

	if (!templateEl) return dates;

	const templateHTML = templateEl.innerHTML;

	for (let i = 0; i < amountOfDates; i++) {
		if (i === 0 && !config.todayOpen) {
			continue; // fast skip today
		}

		if (i === 1 && !config.tomorrowOpen) {
			continue; // Also fast skip tomorrow.
		}

		const date = new Date(now);
		date.setDate(date.getDate() + i);

		const day = date.getDay();
		const dayOfMonth = date.getDate();
		const month = date.getMonth() + 1; // Months are zero-based
		const year = date.getFullYear();

		const ymd = combineYMD(year, month, dayOfMonth);

		let isEnabled = config.enabledDays.includes(day);

		if (config.disabledDates.includes(ymd)) {
			isEnabled = false;
		}

		if (config.forceEnabledDates.includes(ymd)) {
			isEnabled = true;
		}

		if (!isEnabled) {
			continue;
		}

		let dayName = dateFormatterDayOfWeek.format(date);
		const shouldBeRelativeDayName = i === 0 || i === 1 || (!config.tomorrowOpen && i === 2);
		if (shouldBeRelativeDayName) {
			dayName = rtf.format(i, "day");
		}

		const contentTemplate = templateHTML.replace("{dayName}", capitalze(dayName)).replace("{formattedDate}", dateFormatter.format(date));

		dates.push({
			date,
			value: dateFormatterLong.format(date),
			htmlContent: contentTemplate,
		});
	}

	return dates;
}
